/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import React from "react"
import { green } from "../Styles"
function MetaGroup(props) {
  return <div className="flex items-center space-x-4">{props.children}</div>
}

export default MetaGroup
